import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useForm, UseFormReturn } from 'react-hook-form'
import { selectAllTags, TagModel } from '@editor/store/slices/tag.slice'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '@store/store'
import { selectJobById } from '@editor/store/selectors/job.selector'
import { fetchJobById, JobModel } from '@editor/store/slices/job.slice'
import { selectSsmlById, SsmlModel } from '@editor/store/slices/ssml.slice'
import {
  ArticleModel,
  selectArticleById,
} from '@editor/store/slices/article.slice'

export type EditorContextType = {
  job: JobModel | null
  ssml: SsmlModel | null
  article: ArticleModel | null
  formMethods: UseFormReturn
  dispatch: AppDispatch
  editorRef: React.RefObject<HTMLDivElement>
  tags: TagModel[]

  globalTags: TagModel[]
  setGlobalTags: React.Dispatch<React.SetStateAction<TagModel[]>>
  selectedPathTags: TagModel[]
  setSelectedPathTags: React.Dispatch<React.SetStateAction<TagModel[]>>
  selectedRange: Range | null
  setSelectedRange: React.Dispatch<React.SetStateAction<Range | null>>
}

export const EditorContext = React.createContext<Partial<EditorContextType>>({})

export const EditorProvider = ({ children }: { children: React.ReactNode }) => {
  const dispatch: AppDispatch = useDispatch()
  const { jobId } = useParams()
  const job = useSelector((state: RootState) =>
    jobId ? selectJobById(state, jobId) : null
  )
  const ssml = useSelector((state: RootState) =>
    job?.ssml ? selectSsmlById(state, job.ssml) : null
  )
  const article = useSelector((state: RootState) =>
    job?.article ? selectArticleById(state, job.article) : null
  )

  const tags: TagModel[] = useSelector(selectAllTags)

  const formMethods = useForm()
  const editorRef = useRef<HTMLDivElement>(null)
  // Tags global for whole SSML
  const [globalTags, setGlobalTags] = useState<TagModel[]>([])
  // Currently selected tag path SSML
  const [selectedPathTags, setSelectedPathTags] = useState<TagModel[]>([])
  // Saved range of tag path
  const [savedRange, setSavedRange] = useState<Range | null>(null)
  useEffect(() => {
    if (!job && jobId) {
      dispatch(fetchJobById(jobId))
    }
  }, [job, dispatch])

  return (
    <EditorContext.Provider
      value={{
        job,
        ssml,
        article,
        tags,
        formMethods,
        editorRef,
        selectedRange: savedRange,
        setSelectedRange: setSavedRange,
        dispatch,
        globalTags,
        setGlobalTags,
        setSelectedPathTags,
        selectedPathTags,
      }}
    >
      {children}
    </EditorContext.Provider>
  )
}
